import React from 'react';

import Urls from '../../../config/index';
import { Link } from 'react-router-dom';
import { message, Table, Tabs, Popconfirm, Button, Modal, Form, Pagination, Row } from 'antd';
import Serach from '../../utils/serach';
import Add from '../../utils/add';
import EditForm from '../../utils/edit';
import Head from '../../utils/head';
const FormItem = Form.Item;

export default class extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            total: 0,
            list: [],
            serach: {},
            page: 1,
            pageSize: 10
        };
        this.onChange = this.onChange.bind(this);
    }
    componentWillMount() {
        (async (url) => {
            try {
                let response = await fetch(url, {
                    method: 'get',
                    headers: { "Token": "eyJhbGciOiJIUzUxMiJ9.eyJjb20uaWZlbmcuZmxvdy51c2VyLmRvbWFpbi5Vc2VyIjoie1wiY3JlYXRlZFwiOjE1MDM3MTQxNTkwMDAsXCJkZWxldGVkXCI6MCxcImlkXCI6XCI1OTllOGNjZjg4NzEwYjRmZDRlYmM0OTRcIixcIm5hbWVcIjpcImd1Y2hhbmdcIixcInBhc3N3b3JkXCI6XCI2N0MzRjFBOTBBNkIxMDRFRjc2QjM1RDQ1QzhEMjNENlwiLFwicm9sZVwiOjF9In0.mGIFwmBKhdgi1hJ5H5NcsTbgAU7J-Hz7EWWClT73-5oewCXMKCuxEAHRb7nIUpVLZzY_R2J-l1aPbCPfk4nSgg" }
                });
                let result = await response.json();
                if (result.code == 200) {
                    sessionStorage.setItem("partner.options", JSON.stringify(result.data));
                }
            } catch (e) {
                console.log(e);
                message.error('初始化参数失败');
            }
        })(Urls.PartnerUrl.paramList);
        this.getList(this.getListUrl(1, 10));

    }


    getList(url) {
        (async (url) => {
            try {
                let response = await fetch(url, {
                    method: 'get',
                    headers: { "Token": "eyJhbGciOiJIUzUxMiJ9.eyJjb20uaWZlbmcuZmxvdy51c2VyLmRvbWFpbi5Vc2VyIjoie1wiY3JlYXRlZFwiOjE1MDM3MTQxNTkwMDAsXCJkZWxldGVkXCI6MCxcImlkXCI6XCI1OTllOGNjZjg4NzEwYjRmZDRlYmM0OTRcIixcIm5hbWVcIjpcImd1Y2hhbmdcIixcInBhc3N3b3JkXCI6XCI2N0MzRjFBOTBBNkIxMDRFRjc2QjM1RDQ1QzhEMjNENlwiLFwicm9sZVwiOjF9In0.mGIFwmBKhdgi1hJ5H5NcsTbgAU7J-Hz7EWWClT73-5oewCXMKCuxEAHRb7nIUpVLZzY_R2J-l1aPbCPfk4nSgg" }
                });
                let pagerForm = await response.json();
                this.setState(Object.assign(this.state, pagerForm.data))
            } catch (e) {
                console.log(e);
            }
        })(url)
    }

    getListUrl(page, pageSize) {
        return Urls.PartnerStatisticUrl.list + "page=" + page + "&pageSize=" + pageSize;
    }

    onChange(current, pageSize) {
        let url = this.getListUrl(current, pageSize);
        this.setState(Object.assign(this.state, { page: current }, { pageSize: pageSize }));
        this.getList(url);
    }
    serach(serach) {
        this.state.serach = serach;
        this.setState(this.state);
        (async (url) => {
            try {
                let text = '&';
                Object.keys(this.state.serach).forEach((key, index) => {
                    if (serach[key]) {
                        text += (key + "=" + serach[key] + "&");
                    }
                });
                let response = await fetch(url + text, {
                    method: 'get',
                    headers: { "Token": "eyJhbGciOiJIUzUxMiJ9.eyJjb20uaWZlbmcuZmxvdy51c2VyLmRvbWFpbi5Vc2VyIjoie1wiY3JlYXRlZFwiOjE1MDM3MTQxNTkwMDAsXCJkZWxldGVkXCI6MCxcImlkXCI6XCI1OTllOGNjZjg4NzEwYjRmZDRlYmM0OTRcIixcIm5hbWVcIjpcImd1Y2hhbmdcIixcInBhc3N3b3JkXCI6XCI2N0MzRjFBOTBBNkIxMDRFRjc2QjM1RDQ1QzhEMjNENlwiLFwicm9sZVwiOjF9In0.mGIFwmBKhdgi1hJ5H5NcsTbgAU7J-Hz7EWWClT73-5oewCXMKCuxEAHRb7nIUpVLZzY_R2J-l1aPbCPfk4nSgg" }
                });
                let pagerForm = await response.json();
                this.state.list = pagerForm.data.list;
                this.setState(Object.assign(this.state, pagerForm.data))
            } catch (e) {
                console.log(e);
                message.error('查询失败');
            }
        })(this.getListUrl(1, 10))
    }




    render() {
        let partnerOptions = { partnerName: [], area: [] };
        if (sessionStorage.getItem('partner.options')) {
            partnerOptions = JSON.parse(sessionStorage.getItem('partner.options'));
        }
        let serachMetas = [{
            type: 'DatePicker',
            label: '开始时间',
            field: 'beginTime'
        }, {
            type: 'DatePicker',
            label: '结束时间',
            field: 'endTime'
        }, {
            type: 'Select',
            placeholder: '合作商',
            label: '合作商',
            field: 'partner',
            options: partnerOptions.partnerName
        }, {
            type: 'Select',
            placeholder: '地区',
            label: '地区',
            field: 'area',
            options: partnerOptions.area
        }, {
            type: 'Select',
            placeholder: '运营商',
            label: '运营商',
            field: 'operator',
            options: ['联通', '电信', '移动']
        }];
        let addMetas = []
        const columns = [{
            title: '时间',
            dataIndex: 'dateTime',
            key: 'dateTime',
        }, {
            title: '名称',
            dataIndex: 'partner',
            key: 'partner',
        }, {
            title: 'IP总数',
            dataIndex: 'totalIpNum',
            key: 'totalIpNum',
        }, {
            title: '去重IP数',
            dataIndex: 'distinctIpNum',
            key: 'distinctIpNum',
        }, {
            title: 'IP重复率',
            dataIndex: 'ipRepetitionRate',
            key: 'ipRepetitionRate',
        }, {
            title: '代理质量',
            dataIndex: 'proxyQuality',
            key: 'proxyQuality',
        }, {
            title: '行为总量',
            dataIndex: 'behaviorNum',
            key: 'behaviorNum',
        }, {
            title: '分布',
            key: 'action',
            render: record => (
                <span>
                    <Button>地区</Button>
                    <Button>运营商</Button>
                </span >
            )
        }];
        return (
            <div >
                <h2>合作商统计</h2>
                <Head serachMeta={serachMetas} addMeta={addMetas} handleSerach={this.serach.bind(this)} />
                <Table columns={columns} dataSource={this.state.list} pagination={false} />
                <Pagination
                    showQuickJumper
                    showSizeChanger
                    total={this.state.total}
                    className='ant-table-pagination'
                    onChange={this.onChange}
                    onShowSizeChange={this.onChange}
                />
            </div>
        );

    }

}




// WEBPACK FOOTER //
// ./components/sider/partner-statistics.js